export class KDSPermission {
    id: number;    
    name: string;   
    created?: string;    
}